/* YouTube logo badge — one of the few places we keep YouTube-red. */
export default function YouTubeBadge({ size = 22, className = '' }) {
	const w = size;
	const h = size * 0.7;
	return (
		<span className={`inline-flex ${className}`}>
			<svg width={w} height={h} viewBox="0 0 28 20" fill="none" aria-hidden="true">
				<rect width="28" height="20" rx="6" fill="#FF0033" />
				<path d="M11 6l7 4-7 4V6z" fill="#fff" />
			</svg>
		</span>
	);
}

/* Google "G" mark for the OAuth modal header. */
export function GoogleG({ size = 18 }) {
	return (
		<svg width={size} height={size} viewBox="0 0 48 48" aria-hidden="true">
			<path fill="#4285F4" d="M45 24c0-1.6-.1-2.8-.4-4H24v7.5h12c-.2 2-1.6 5-4.6 7l7 5.4C42.7 42 45 36 45 24z" />
			<path fill="#34A853" d="M24 46c6 0 11-2 14.7-5.4l-7-5.4c-2 1.3-4.5 2-7.7 2-5.9 0-10.9-4-12.7-9.3l-7.3 5.6C7.7 41 15.3 46 24 46z" />
			<path fill="#FBBC05" d="M11.3 27.9c-.5-1.4-.7-2.9-.7-4.4s.3-3 .7-4.4l-7.3-5.6C2.4 16.5 1.6 20.1 1.6 24s.8 7.5 2.4 10.5l7.3-5.6z" />
			<path fill="#EA4335" d="M24 9.5c3.3 0 6.2 1.1 8.5 3.3l6.3-6.3C35 2.9 30 1 24 1 15.3 1 7.7 6 4 13.5l7.3 5.6C13.1 13.5 18.1 9.5 24 9.5z" />
		</svg>
	);
}
